import router from '@/router'
import { v4 as uuidv4 } from 'uuid'

export function getValueByKey(array, key, resultKey) {
    if (!array || array && !array.length || !key) return
    const obj = array.find(e => e.name === key)
    return obj && obj[resultKey] || ''
}

export function getObjectByKey({array, arrayKey, key}) {
  if (!array || (array && !array.length) || !key) return
  const obj = array.find(e => e[arrayKey] === key)
  return obj || ''
}

export async function toClipBoard(value, msg = 'Copied!') {
    await navigator.clipboard.writeText(value).then(() => {
        this.$toasted.global.success({ message: msg })
    })
}

export function deleteByPath(obj, path) {
    if (typeof path === 'string') {
        path = path.split('.');
    }

    if (path.length === 1 && !path[0].includes('[]')) {
        delete obj[path[0]];
        return obj
    }

    if (path[0].includes('[]')) {
        const arrayName = path[0].split('[]')[0];
        const targetName = path[0].split('[]')[1];

        if (arrayName && obj[arrayName] && Array.isArray(obj[arrayName]) && obj[arrayName].length) {
            obj[arrayName] = obj[arrayName].map(el => deleteByPath(el, targetName))
        }

    // eslint-disable-next-line no-prototype-builtins
    } else if (obj.hasOwnProperty(path[0]) && typeof obj[path[0]] === 'object') {
        deleteByPath(obj[path[0]], path.slice(1));
        if (Object.keys(obj[path[0]]).length === 0) {
            delete obj[path[0]];
        }
    }

    return obj
}

export function getNestedValueFromObj(obj, path) {
    if (!path || !Object.keys(obj).length) return
    return path.split('.').reduce((acc, part) => acc && acc[part], obj)
}

export function addByPath(object, path, value) {
    const keys = path.split('.');
    let current = object;

    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) {
        current[keys[i]] = (keys[i + 1] === '[]' ? [] : {});
      }
      current = current[keys[i]];
    }

    if (keys[keys.length - 1] === '[]') {
      current.push(value);
    } else {
      current[keys[keys.length - 1]] = value;
    }

    return object;
}

export function splitArrayByFixedSize(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
}

export function getTimestampFromObjectId(objectId) {
    return new Date(parseInt(objectId.slice(0, 8), 16) * 1000);
}

export function forceDeleteTooltipPopover () {
    const popoverElement = document.querySelector('.vue-popover');
    if (popoverElement) {
        popoverElement.remove();
    }
}
export function dispatchEventToRef({ refEl, eventName }) {
    if (!refEl) return
    const event = new Event(eventName);
    refEl.dispatchEvent(event);
}
export function isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function compareObjectFields({ objA, objB, compareKeys = [], strict = false }) {
    if (
      typeof objA !== 'object' ||
      typeof objB !== 'object' ||
      objA === null ||
      objB === null
    ) {
      if (strict) {
        return objA === objB
      } else {
        return objA == objB
      }
    }

    const keysA = Object.keys(objA).filter(
      key => !compareKeys.length || compareKeys.includes(key),
    )
    const keysB = Object.keys(objB).filter(
      key => !compareKeys.length || compareKeys.includes(key),
    )

    if (keysA.length !== keysB.length) return false

    return keysA.every(key => {
      if (Array.isArray(objA[key]) && Array.isArray(objB[key])) {
        if (objA[key].length !== objB[key].length) return false
        return objA[key].every((itemA, index) => {
          return compareObjectFields({
            objA: itemA,
            objB: objB[key][index],
            compareKeys,
            strict
          })
        })
      }
      return compareObjectFields({
        objA: objA[key],
        objB: objB[key],
        compareKeys,
        strict
      })
    })
  }

export function isMatchedByCoin(currencyList, value, coin, type = 'address') {
  const coinDataAlert = currencyList.find(el => el.key === coin);
  const regexKey = type === 'tx' ? 'txRegex' : 'addressRegex';
  const valueToTest = value;

  if (!coinDataAlert?.[regexKey] || !valueToTest) return false;

  try {
    const regex = new RegExp(coinDataAlert[regexKey]);
    return regex.test(valueToTest);
  } catch (e) {
    return false;
  }
}

export function clearStringForSelector(string) {
  if (!string) return
  return string.replace(/[^a-zA-Z0-9_-]/g, '')
}

export function getQueryParams() {
  return router.currentRoute.query
}

export function contactSupport() {
  return window.location.href = 'mailto:support@glprotocol.com'
}

export const addUniqueIdToArray = ({ array = [], key = 'id' }) => {
  return array.map((item) => ({
    ...item,
    [key]: uuidv4(),
  }))
}

export const findDuplicateValues = ({ array, key }) => {
  const seen = new Set()
  const duplicates = new Set()

  array.forEach(obj => {
    const val = obj[key]
    if (seen.has(val)) {
      duplicates.add(val)
    } else {
      seen.add(val)
    }
  })

  return [...duplicates]
}

export const mapDataByKeys = ({ items = [], keys = [] }) => {
  if (!Array.isArray(items) || !Array.isArray(keys)) return []
  return items.map(item => keys.map(h => item[h] ?? ''))
}

export const formatScreenshot = async (shot) => {
  if (!shot?.image) return shot

  if (shot.image.startsWith('data:')) {
    return shot
  }

  try {
    const directRes = await fetch(shot.image)
    if (directRes.ok) {
      return shot
    }
  } catch (err) {
    console.log(err)
  }

  const token = localStorage.getItem('token')
  const separator = shot.image.includes('?') ? '&' : '?'
  const urlWithParams = `${shot.image}${separator}authorization=${token}&bucket=screenshots`

  try {
    const res = await fetch(urlWithParams)
    if (res.ok) {
      return {
        ...shot,
        image: res.url,
      }
    }
  } catch (err) {
    console.error(err)
  }

  return shot
}

export function detectMimeType(input) {
  if (!input || input.startsWith('ipfs://')) {
    return ''
  }

  let cleaned = input.startsWith('data:')
    ? input.split(',')[1]
    : input

  if (!/^[A-Za-z0-9+/=_-]+$/.test(cleaned)) {
    return ''
  }

  cleaned = cleaned
    .replace(/[\r\n\s]/g, '')
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  while (cleaned.length % 4 !== 0) {
    cleaned += '='
  }

  let binary
  try {
    binary = atob(cleaned)
  } catch (e) {
    return ''
  }

  const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))

  if (bytes[0] === 0x89 && bytes[1] === 0x50) return 'image/png'
  if (bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF) return 'image/jpeg'
  if (bytes[0] === 0x47 && bytes[1] === 0x49) return 'image/gif'
  if (
    bytes[0] === 0x52 &&
    bytes[1] === 0x49 &&
    bytes[2] === 0x46 &&
    bytes[3] === 0x46
  ) return 'image/webp'

  if (binary.trim().startsWith('<')) return 'image/svg+xml'

  return ''
}


